__turbopack_context__.v({
  "latest_news_row": "_2yOugG_latest_news_row",
  "latest_news_row_splide_arrow": "_2yOugG_latest_news_row_splide_arrow",
  "latest_news_row_title": "_2yOugG_latest_news_row_title",
});
